// Page paths that were renamed, old -> new. The router keeps a `redirect`
// record for each old path (bookmarks keep working); this table is for what
// the router never sees: taskbar tabs and server pins saved under the old
// path (src/utils/taskbar.js keys every path through currentPathOf). Without it a saved tab keeps its old key, clicking it redirects to the
// new path, and the strip opens a SECOND tab for the same page.
//
// #441 (spec 2026-10-09 §B5): /backoffice/orders-new -> /backoffice/orders-overview.
export const LEGACY_PATHS = Object.freeze({
	"/backoffice/orders-new": "/backoffice/orders-overview"
});

// "/backoffice/orders-new" -> "/backoffice/orders-overview"; anything else
// comes back unchanged. Path only (no query / hash).
export function currentPathOf(path) {
	if (typeof path !== "string") return path;
	return Object.prototype.hasOwnProperty.call(LEGACY_PATHS, path) ? LEGACY_PATHS[path] : path;
}

// Same, for a full path: the query and hash are kept.
// "/backoffice/orders-new?tab=all#x" -> "/backoffice/orders-overview?tab=all#x".
export function currentHrefOf(href) {
	if (typeof href !== "string" || href === "") return href;
	const cut = href.search(/[?#]/);
	const path = cut === -1 ? href : href.slice(0, cut);
	const rest = cut === -1 ? "" : href.slice(cut);
	return currentPathOf(path) + rest;
}

export function isLegacyPath(pathOrHref) {
	if (typeof pathOrHref !== "string") return false;
	return Object.prototype.hasOwnProperty.call(LEGACY_PATHS, pathOrHref.split(/[?#]/)[0]);
}

